<template>
  <div id="views-landing" class="ngo-main-page">
    <section class="hero-section">
      <img
        class="hero-background"
        src="../../../assets/ngoimgs/landing page.png"
        alt="Nigeria health partners platform"
      />

      <div class="hero-overlay"></div>

      <div class="hero-content">
        <div class="hero-badge">
          <img
            src="../../../assets/ngoimgs/Coat-of-arms.png"
            class="hero-badge__image"
            alt="Coat of arms"
          />
          <div>
            <span class="hero-badge__eyebrow">Federal Ministry of Health</span>
            <span class="hero-badge__subtext">DHPRS digital coordination platform</span>
          </div>
        </div>

        <div class="hero-copy">
          <p class="hero-kicker">National Health Inventory</p>
          <h1>Welcome to Nigeria Health Partners' Projects and Data Mapping Platform</h1>
          <p class="hero-description">
            Mapping health partners, projects, data activities, and NGO registrations across Nigeria
            through one modern national workspace.
          </p>
        </div>

        <div class="hero-summary">
          <div class="summary-card">
            <span class="summary-card__label">Explore</span>
            <strong class="summary-card__value">Projects, datasets, NGOs</strong>
          </div>
          <div class="summary-card">
            <span class="summary-card__label">Built for</span>
            <strong class="summary-card__value">Coordination and visibility</strong>
          </div>
        </div>
      </div>
    </section>

    <section id="card-section" class="landing-services container">
      <div class="section-heading">
        <div>
          <p class="section-kicker">Platform Services</p>
          <h2>Explore the core health inventory</h2>
        </div>
      </div>

      <div class="row service-grid">
        <div class="col-12 col-md-6 col-xl-3 mb-4">
          <Cards to="/inventory/project">
            <template v-slot:image>
              <img src="../../../assets/ngoimgs/book.png" class="img-fluid card-icon" width="50" />
            </template>
            <template v-slot:paragraph>Project Inventory</template>
            <template v-slot:subtitle>Explore and submit health intervention projects.</template>
            <template v-slot:subtitle2>
              <router-link to="inventory/project-inventory">Explore projects</router-link>
              <router-link to="inventory/submit-project">Submit projects</router-link>
            </template>
          </Cards>
        </div>
        <div class="col-12 col-md-6 col-xl-3 mb-4">
          <Cards to="//inventory/dataset">
            <template v-slot:image>
              <img src="../../../assets/ngoimgs/book.png" class="img-fluid card-icon" width="50" />
            </template>
            <template v-slot:paragraph>Data Inventory</template>
            <template v-slot:subtitle>Explore and submit all health datasets.</template>
            <template v-slot:subtitle2>
              <router-link to="inventory/project-inventory">Explore datasets</router-link>
              <router-link to="#">Submit datasets</router-link>
            </template>
          </Cards>
        </div>

        <!-- <div class="col-12 col-md-6 col-xl-3 mb-4">
          <Cards to="/inventory/dataset">
            <template v-slot:image>
              <img src="../../../assets/ngoimgs/book.png" class="img-fluid card-icon" width="50" />
            </template>
            <template v-slot:paragraph>Data Inventory</template>
            <template v-slot:subtitle>Explore and submit all health datasets.</template>
            <template v-slot:subtitle2>
              <router-link to="inventory/dataset-inventory">Explore datasets</router-link>
              <b-button class="submitdataset" @click.stop.prevent="submitdataset">
                Submit datasets
              </b-button>
            </template>
          </Cards>
        </div> -->

        <div class="col-12 col-md-6 col-xl-3 mb-4">
          <Cards to="/inventory/stakeholders">
            <template v-slot:image>
              <img
                src="../../../assets/ngoimgs/social-care.png"
                class="img-fluid card-icon"
                width="50"
              />
            </template>
            <template v-slot:paragraph>Stakeholder Inventory</template>
            <template v-slot:subtitle>View a consolidated list of ecosystem stakeholders.</template>
          </Cards>
        </div>

        <div class="col-12 col-md-6 col-xl-3 mb-4">
          <Cards to="ngo/landing">
            <template v-slot:image>
              <img
                src="../../../assets/ngoimgs/Untitled-2.png"
                class="img-fluid card-icon"
                width="50"
              />
            </template>
            <template v-slot:paragraph>NGO Inventory</template>
            <template v-slot:subtitle>
              Register NGOs, submit annual reports, view registered NGOs, and follow the
              registration steps.
            </template>
          </Cards>
        </div>
      </div>
    </section>

    <section id="about-us" class="about-section container">
      <div class="about-shell">
        <div class="about-copy">
          <p class="section-kicker">About This Site</p>
          <h2>A central digital inventory for health partners, projects, datasets, and NGOs</h2>
          <p id="about-us-paragraph" class="custom-style">
            This central web-based inventory has been developed by the Department of Health
            Planning, Research and Statistics (DHPRS) of the Federal Ministry of Health (FMoH) to
            compile all health data and intervention projects carried out by international partners
            and non-governmental organisations across all health domains in the country.
          </p>
          <p class="custom-style">
            The platform also captures details of Non Governmental Organizations (NGOs) that have
            been registered with the Federal Ministry of Health under the purview of the NGO branch
            at the Health Systems Strengthening division of the DHPRS-FMoH.
          </p>

          <router-link to="ngo/about" class="about-link">
            <span>See more</span>
            <i class="fa fa-angle-right"></i>
          </router-link>
        </div>

        <div class="about-highlights">
          <div class="highlight-card">
            <span class="highlight-card__label">Primary role</span>
            <strong class="highlight-card__value">Coordination and accountability</strong>
          </div>
          <div class="highlight-card">
            <span class="highlight-card__label">Coverage</span>
            <strong class="highlight-card__value">Projects, data, stakeholders, NGOs</strong>
          </div>
          <div class="highlight-card">
            <span class="highlight-card__label">Owned by</span>
            <strong class="highlight-card__value">DHPRS, Federal Ministry of Health</strong>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { news as NEWS } from '../config/api-modules/api.organization';
import Cards from './bits/bits.index';

export default {
  name: 'ViewsLanding',
  components: {
    Cards,
  },
  data() {
    return {
      news: [],
    };
  },
  mounted() {
    NEWS().then((data) => {
      this.news = data.data.results;
    });
  },

  methods: {
    loadLink(link) {
      window.open(link);
    },

    submitdataset() {
      localStorage.setItem('submitdataroute', '/inventory/submit-dataset');
      this.$router.push('/inventory/submit-dataset');
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@500;600;700&display=swap');

.ngo-main-page {
  padding-top: clamp(1.5rem, 2vw, 2rem);
  padding-bottom: 3rem;
  background: radial-gradient(circle at top left, rgba(48, 171, 76, 0.12), transparent 24%),
    linear-gradient(180deg, #f4faf5 0%, #eef5ef 100%);
  overflow-x: hidden;
}

.hero-section {
  position: relative;
  min-height: 36rem;
  overflow: hidden;
  margin: 0 1rem;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 32px;
  box-shadow: 0 28px 80px rgba(17, 41, 24, 0.14);
}

.hero-background {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(7, 25, 13, 0.9), rgba(16, 56, 28, 0.7)),
    linear-gradient(180deg, rgba(9, 32, 17, 0.35), rgba(9, 32, 17, 0.85));
}

.hero-content {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(260px, 0.75fr);
  align-items: end;
  gap: 1.5rem 2rem;
  min-height: 36rem;
  max-width: 1320px;
  margin: 0 auto;
  padding: 3.25rem 2rem 4.25rem;
  color: #ffffff;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  grid-column: 1 / -1;
  width: fit-content;
  padding: 0.9rem 1.1rem;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(14px);
}

.hero-badge__image {
  width: 68px;
  height: 68px;
  object-fit: contain;
}

.hero-badge__eyebrow,
.hero-badge__subtext,
.hero-kicker,
.section-kicker,
.summary-card__label,
.highlight-card__label {
  display: block;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.hero-badge__eyebrow,
.hero-kicker,
.section-kicker {
  font-size: 0.78rem;
  font-weight: 700;
}

.hero-badge__subtext {
  margin-top: 0.25rem;
  font-size: 0.72rem;
  color: rgba(255, 255, 255, 0.72);
}

.hero-kicker {
  margin-bottom: 0.65rem;
  color: rgba(255, 255, 255, 0.76);
}

.hero-copy h1 {
  max-width: 54rem;
  margin-bottom: 1rem;
  font-family: 'Raleway', sans-serif;
  font-size: clamp(2.2rem, 4vw, 4.2rem);
  line-height: 1.05;
  text-wrap: balance;
}

.hero-description {
  max-width: 42rem;
  margin: 0;
  font-size: 1rem;
  line-height: 1.85;
  color: rgba(255, 255, 255, 0.84);
}

.hero-summary {
  display: grid;
  grid-template-columns: 1fr;
  align-self: stretch;
  gap: 1rem;
}

.summary-card {
  padding: 1.15rem 1.2rem;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(14px);
}

.summary-card__label,
.highlight-card__label {
  margin-bottom: 0.5rem;
  font-size: 0.72rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.72);
}

.summary-card__value {
  font-size: 1rem;
  color: #ffffff;
}

.landing-services,
.about-section {
  margin-top: 4rem;
}

.landing-services {
  position: relative;
  z-index: 2;
}

.section-heading {
  margin-bottom: 1.5rem;
}

.section-kicker {
  margin-bottom: 0.45rem;
  color: #2c8d41;
}

.section-heading h2,
.about-copy h2 {
  margin: 0;
  font-family: 'Raleway', sans-serif;
  color: #132218;
}

.service-grid {
  margin-top: 0.5rem;
}

.ngo-main-page ::v-deep .landing-card {
  min-height: 100%;
}

.ngo-main-page ::v-deep .landing-card__subtitle {
  font-size: 0.96rem;
}

.card-icon {
  filter: drop-shadow(0 10px 20px rgba(48, 171, 76, 0.12));
}

#about-us-paragraph {
  color: #090909;
}

.about-shell {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(280px, 0.8fr);
  gap: 1.4rem;
  padding: 2rem;
  border: 1px solid rgba(24, 57, 31, 0.08);
  border-radius: 28px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.94), rgba(245, 250, 246, 0.96)), #ffffff;
  box-shadow: 0 24px 60px rgba(20, 55, 31, 0.07), inset 0 1px 0 rgba(255, 255, 255, 0.72);
}

.about-copy p {
  margin-bottom: 1rem;
  line-height: 1.8;
  color: #51685b;
}

.custom-style {
  font-family: 'Roboto', sans-serif;
}

.about-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
  padding: 0.9rem 1.1rem;
  border-radius: 16px;
  background: rgba(48, 171, 76, 0.1);
  color: #1f6f31;
  text-decoration: none;
  font-weight: 700;
}

.about-highlights {
  display: grid;
  gap: 1rem;
}

.highlight-card {
  padding: 1.2rem;
  border: 1px solid rgba(24, 57, 31, 0.08);
  border-radius: 22px;
  background: linear-gradient(180deg, rgba(251, 253, 251, 0.96), rgba(241, 247, 242, 0.96));
}

.highlight-card__label {
  color: #2c8d41;
}

.highlight-card__value {
  color: #183322;
  line-height: 1.5;
}

.submitdataset {
  padding: 0;
  background-color: transparent;
  color: #30ab4c;
  border: none;
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
}

.submitdataset:hover,
.submitdataset:active {
  background-color: transparent !important;
  color: #1f6f31 !important;
  border: none !important;
  box-shadow: none !important;
}

.submitdataset:focus {
  background-color: transparent;
  color: #1f6f31;
  border: none;
  box-shadow: none;
}

@media screen and (max-width: 991px) {
  .ngo-main-page {
    padding-top: clamp(4.5rem, 8vw, 5.5rem);
    padding-bottom: 2.25rem;
  }

  .hero-section,
  .hero-content {
    min-height: auto;
  }

  .hero-content {
    grid-template-columns: 1fr;
    align-items: start;
    gap: 1.25rem;
    padding: 4rem 1.4rem 3rem;
  }

  .hero-summary,
  .about-shell {
    grid-template-columns: 1fr;
  }

  .hero-copy h1 {
    max-width: 44rem;
  }
}

@media screen and (max-width: 768px) {
  .ngo-main-page {
    padding-top: clamp(4.75rem, 10vw, 5.75rem);
    padding-bottom: 1.5rem;
  }

  .hero-section {
    margin: 0 0.75rem;
    border-radius: 28px;
  }

  .hero-badge {
    width: 100%;
    padding: 1rem;
  }

  .hero-badge__image {
    width: 56px;
    height: 56px;
  }

  .hero-copy h1 {
    font-size: 2.05rem;
  }

  .hero-description {
    font-size: 0.95rem;
    line-height: 1.7;
  }

  .hero-summary {
    grid-template-columns: 1fr;
  }

  .summary-card {
    padding: 1rem;
    border-radius: 18px;
  }

  .landing-services,
  .about-section {
    margin-top: 2.5rem;
  }

  .section-heading {
    margin-bottom: 1.15rem;
  }

  .about-shell {
    padding: 1.25rem;
    border-radius: 22px;
  }

  .page-title {
    font-size: small;
  }
}

@media screen and (max-width: 575px) {
  .ngo-main-page {
    padding-top: 4.75rem;
  }

  .hero-section {
    margin: 0 0.5rem;
    border-radius: 22px;
  }

  .hero-content {
    gap: 1.15rem;
    padding: 3.4rem 1rem 2.4rem;
  }

  .hero-copy h1 {
    font-size: 1.72rem;
    line-height: 1.08;
  }

  .hero-badge {
    gap: 0.85rem;
    padding: 0.9rem;
    border-radius: 18px;
  }

  .hero-badge__eyebrow,
  .hero-kicker,
  .section-kicker {
    letter-spacing: 0.12em;
  }

  .hero-badge__subtext,
  .hero-description,
  .about-copy p,
  .highlight-card__value {
    font-size: 0.9rem;
  }

  .hero-description {
    line-height: 1.65;
  }

  .section-heading h2,
  .about-copy h2 {
    font-size: 1.45rem;
    line-height: 1.2;
  }

  .ngo-main-page ::v-deep .landing-card {
    min-height: 19rem;
    border-radius: 22px;
  }

  .ngo-main-page ::v-deep .landing-card__content {
    padding: 1.15rem;
  }

  .ngo-main-page ::v-deep .landing-card__icon {
    width: 60px;
    height: 60px;
    margin-bottom: 1rem;
    border-radius: 18px;
  }

  .ngo-main-page ::v-deep .landing-card__title {
    font-size: 1rem;
  }

  .ngo-main-page ::v-deep .landing-card__subtitle,
  .ngo-main-page ::v-deep .landing-card__actions {
    font-size: 0.88rem;
    line-height: 1.55;
  }

  .about-shell {
    padding: 1rem;
    border-radius: 18px;
  }
}
</style>
